import * as React from "react";
import {connect} from "react-redux";
import {option, Option} from "ts-option";
import Job from "../../../model/job/Job";
import User from "../../../model/user/User";
import {updateJobAgent} from "../../../store/action/job/job";
import Toast from "../../helper/Toast";
import {Dispatch} from "redux";
import AgentSelector from "../../lead/v4/agentSelector/AgentSelector";

interface IComponentProps {
	/**
	 * Job.
	 */
	job: Job;
}

interface IDispatchProps {
	/**
	 * Update job agent action.
	 * @param {string} jobId
	 * @param {Option<string>} agentId
	 */
	updateJobAgent: (jobId: string, agentId: Option<string>) => void;
}

type Props = IComponentProps & IDispatchProps;

class JobAgentSelector extends React.PureComponent<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<AgentSelector agentId={this.props.job.agentId} onChange={this.onChange}/>
		);
	}

	onChange(user: User) {
		if (this.props.job) {
			this.props.updateJobAgent(
				this.props.job.id,
				option(user.id),
			);
		}
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateJobAgent: (jobId: string, agentId: Option<string>) => dispatch(
			updateJobAgent(
				jobId,
				agentId,
				() => Toast.success("Job agent changed", "Job details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Job details update"))
		)
	}
}

export default connect(null, mapDispatchToProps)(JobAgentSelector)
